var $ = require('jquery'),
    popup = require('window-popup').windowPopup;

module.exports = function(el) {
    var $el = $(el);

    $el.on('click', function(e) {
        e.preventDefault();

        popup(600, 500, $el.attr('href'));
    });
};



//////////////////
// WEBPACK FOOTER
// ./modules/windowPopup.js
// module id = 12
// module chunks = 0